
import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { User, Building } from "lucide-react";

interface AccountTypeSelectionProps {
  field: any;
}

const AccountTypeSelection: React.FC<AccountTypeSelectionProps> = ({ field }) => {
  const handleAccountTypeChange = (value: string) => {
    console.log("Account type changed to:", value);
    field.onChange(value);
  };

  return (
    <FormItem className="space-y-4 md:space-y-6 mb-6 md:mb-8">
      <FormLabel className="text-base md:text-lg font-bold text-foreground">Choose Your Account Type</FormLabel>
      <FormControl>
        <RadioGroup
          onValueChange={handleAccountTypeChange}
          value={field.value}
          className="grid grid-cols-1 gap-3 md:gap-4"
        >
          <div className="relative">
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="user" id="user-type" />
              <Label 
                htmlFor="user-type" 
                className="flex items-center gap-3 md:gap-6 p-4 md:p-6 border-2 border-border/50 rounded-xl md:rounded-2xl cursor-pointer transition-all duration-300 hover:bg-accent/30 hover:border-primary/30 peer-checked:border-primary peer-checked:bg-primary/5 peer-checked:shadow-lg peer-checked:shadow-primary/10 hover:scale-[1.01] md:hover:scale-[1.02] flex-1"
                onClick={() => handleAccountTypeChange("user")}
              >
                <div className="flex items-center justify-center w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-primary/15 to-primary/25 rounded-lg md:rounded-xl shadow-sm">
                  <User className="h-5 w-5 md:h-7 md:w-7 text-primary" />
                </div>
                <div className="flex-1 space-y-1 md:space-y-2">
                  <div className="font-bold text-foreground text-lg md:text-xl">Student/Teen</div>
                  <div className="text-xs md:text-sm text-muted-foreground leading-relaxed">Join to learn, connect, and grow your skills with mentors and peers</div>
                </div>
              </Label>
            </div>
          </div>
          
          <div className="relative">
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="startup" id="startup-type" />
              <Label 
                htmlFor="startup-type" 
                className="flex items-center gap-3 md:gap-6 p-4 md:p-6 border-2 border-border/50 rounded-xl md:rounded-2xl cursor-pointer transition-all duration-300 hover:bg-accent/30 hover:border-secondary/30 peer-checked:border-secondary peer-checked:bg-secondary/5 peer-checked:shadow-lg peer-checked:shadow-secondary/10 hover:scale-[1.01] md:hover:scale-[1.02] flex-1"
                onClick={() => handleAccountTypeChange("startup")}
              >
                <div className="flex items-center justify-center w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-secondary/15 to-secondary/25 rounded-lg md:rounded-xl shadow-sm">
                  <Building className="h-5 w-5 md:h-7 md:w-7 text-secondary" />
                </div>
                <div className="flex-1 space-y-1 md:space-y-2">
                  <div className="font-bold text-foreground text-lg md:text-xl">Startup/Organization</div>
                  <div className="text-xs md:text-sm text-muted-foreground leading-relaxed">Recruit talent, find mentors, and grow your business network</div>
                </div>
              </Label>
            </div>
          </div>
        </RadioGroup>
      </FormControl>
      <FormMessage className="text-red-600 font-medium" />
    </FormItem>
  );
};

export default AccountTypeSelection;
